import { useState, useEffect, useRef, useContext } from "react";
import EventContext from "../store/event-context";
import Button from "@mui/material/Button";
import ActionButton from './actionButton'
import {
  Box,
  Grid,
  Typography,
  Divider,
} from "@mui/material";
import AlertDialog from './alertDialog';

const ActorDetails = ({ actor, actorStateChange, clearActor, refresh }) => {

  //const [didUndo, setDidUndo] = useState(false);
  const eventctx = useContext(EventContext);
  const didUndo = useRef(false);
  const orientationPortrait = (window.innerWidth < window.innerHeight);
  const paddingTijd = (window.innerHeight < 600)? 1: 3;

  console.log("Render ActorDetails - didUndo: ", didUndo.current);

  const finishActor = () => {
    const url = actor.links.finish.url;
    didUndo.current = false;
    //setDidUndo(false);
    actorStateChange(url);
    refresh();
  };

  const clearScreen = () => {
    didUndo.current = false;
    //setDidUndo(false);
    clearActor();
  };

  const undoActor = () => {
    //console.log(eventctx.event)
    let nrPart = actor.capnr
    if (eventctx.event && eventctx.event.colors.length === 1) {
         const hlpArray = actor.capnr.split(":");
         nrPart = hlpArray[1]; 
    }
    if (actor.state === "busy") {
      if (
        !window.confirm(
          "Te water gaan van zwemmer " +
            nrPart +
            " ongedaan maken? \n\nDe zwemmer zal dan te boek staan als niet begonnen met zwemmen, en niet meer in de lijst met actieve zwemmers verschijnen"
        )
      ) {
        console.log("Not approved");
        return;
      }
    } else if (actor.state === "ready") {
      if (
        !window.confirm(
          "Zwemmer " +
            nrPart +
            " staat klaar om te gaan zwemmen. Ongedaan maken? \n\nDe zwemmer zal dan weer te boek staan als Geregistreerd."
        )
      ) {
        console.log("Not approved");
        return;
      }
    } else {
      if (
        !window.confirm(
          "Uit het water komen van zwemmer " +
            nrPart +
            " ongedaan maken? \n\nDe zwemmer zal dan te boek staan als niet uit het water gekomen, en weer in de lijst met actieve zwemmers verschijnen."
        )
      ) {
        console.log("Not approved");
        return;
      }
    }

    const url = actor.links.undo.url;
    didUndo.current = true;
    //setDidUndo(true);
    actorStateChange(url);
    refresh();
  };

  return (
    <Box id="ActorOutDetails" padding={1} >
      <Divider orientation="horizontal" flexItem />
      {(actor.firstName || actor.lastName) &&
      <Box marginTop={1} paddingY={0.3} paddingX={1} sx={{ backgroundColor: 'common.white', maxWidth: orientationPortrait ? '100%' : '330px' }} >
        <Typography variant="h4" color="textPrimary" sx={{py: 0.5}}>
          {actor.displayCapnr}
        </Typography>
        <Typography variant="h4" color="textPrimary" sx={{paddingTop: 0.5}}>
          {actor.firstName}
        </Typography>
        <Typography variant="h6" color="textSecondary" sx={{paddingBottom: 0.5}}>
          {actor.lastName}
        </Typography>
        { (actor.state !== "initial" && actor.state !== "registered") && 
          <Typography variant="h6" color="textSecondary" sx={{paddingTop: paddingTijd, lineHeight: 1.4 }}>
            {"Afstand: " + actor.distance +  " km"}
          </Typography>}
        { (actor.state !== "initial" && actor.state !== "registered") &&
          <Typography variant="h6" color="textSecondary" sx={{paddingBottom: 1, lineHeight: 1.4 }}>
            {"Team: " + (actor.teamName ? actor.teamName : "-") }
          </Typography>}
        { (actor.state === "busy" || actor.state === "done") &&
          actor.started_at && actor.started_at !== "-" && (
          <Typography variant="h6" color="textSecondary" sx={{ lineHeight: 1.5}}>
            {"Gestart op: " + actor.started_at }
          </Typography>
        )}
        { (actor.state === "ready") && 
          <Typography color="textPrimairy" sx={{ lineHeight: 1.4, fontSize: "1.1rem"}}>
            (Nog) niet in het water gemeld!
          </Typography>
        }
        { (actor.state === "busy" || actor.state === "done") && actor.duration && actor.duration !== "-" && (
          <Typography variant="h4" color="textPrimary" sx={{paddingBottom: 1, paddingTop: paddingTijd}}>
            {"Tijd: " + actor.duration }
          </Typography>
        )}
      </Box>}

      <Box id="ButtonsBox" position="absolute" bottom="8px" width='99%' paddingRight='8px' >
      {actor.state && (
      <Grid container id="FinishButtonGrid" direction="column" justifyContent="center" sx={{ paddingTop: 1, maxWidth: orientationPortrait ? '100%' : '330px' }}>
        <Grid item id="FinishButtonGridItem">
          <Box paddingX={4} >
          <ActionButton id="FinishButton" fullWidth color="buttonOrange" onClick={ finishActor } disabled={actor.state !== "busy"} >
            uit het water
          </ActionButton>
          </Box>
        </Grid>
      </Grid>)}
      
      {actor.state && (
        <Grid container id="StepBackOutButtonGrid" direction="row" justifyContent="center" spacing={1} sx={{ paddingTop: 0.5, maxWidth: orientationPortrait ? '100%' : '330px'}}>
          <Grid item id="StepBackOutButtonGridItem" sx={{ width: orientationPortrait? '45%' : '155px' }} >
            <Box my={1} marginLeft={3} justifyContent="center" >
              <Button id="StepBackOutButton" variant="outlined" size="small" color="secondary" onClick={undoActor} disabled={(actor.state !== "done")} fullWidth >
                Herstel
              </Button>
            </Box>
          </Grid>
          <Grid item id="ClearOutButtonGridItem"sx={{ width: orientationPortrait? '45%' : '155px' }} >
            <Box my={1} marginRight={3} justifyContent="center" >
              <Button id="ClearOutButton" variant="contained" size="small" color="primary" onClick={clearScreen} fullWidth >
                Clear
              </Button>
            </Box>
          </Grid>
        </Grid>
      )}
      </Box>
      {/*(actor.state === "initial" || actor.state === "registered") && (
        <Alert severity="error">
          {" "}
          De deelnemer is niet aangemeld of het capnr is niet (meer) in gebruik.\nDeelnemer kan beste
          langs aanmeldbalie gaan om te verifieren.{" "}
        </Alert>
      )*/}
      {(actor.state === "initial" || actor.state === "registered") && !didUndo.current && <AlertDialog
        onClose={clearScreen}
        message='De deelnemer is niet aangemeld of het capnummer is niet (meer) in gebruik.\nDeelnemer kan beste langs aanmeldbalie gaan om te verifiëren.'
        severity="error"
        />}
  </Box>
  );
};

export default ActorDetails;
